import * as actions from "../constants/addressConstants";
import { Reducer } from "redux";

interface IAction {
  type: string;
  payload?: string;
}

export const addressListReducer: Reducer = (
  state = { addresses: [] },
  action: IAction
) => {
  switch (action.type) {
    case actions.USER_ADDRESS_REQUEST:
      return { loading: true };
    case actions.USER_ADDRESS_ADD_REQUEST:
      return { loading: true };
    case actions.USER_ADDRESS_UPDATE_REQUEST:
      return { loading: true };
    case actions.USER_ADDRESS_DELETE_REQUEST:
      return { loading: true };
    case actions.USER_ADDRESS_REQUEST_SUCCESS:
      return { loading: false, addresses: action.payload };
    case actions.USER_ADDRESS_ADD_SUCCESS:
      return {
        loading: false,
        addresses: action.payload,
      };
    case actions.USER_ADDRESS_UPDATE_SUCCESS:
      return { loading: false, addresses: action.payload };
    case actions.USER_ADDRESS_DELETE_SUCCESS:
      return { loading: false, addresses: action.payload };
    case actions.USER_ADDRESS_REQUEST_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_ADDRESS_ADD_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_ADDRESS_UPDATE_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_ADDRESS_DELETE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
